import DropDownList from "@/components/Dropdown";
import { EnumStatus, ModeUI } from "@/constants/enum";
import { useGetDropDownBusinessUnitsQuery } from "@/services/businessunit.service";
import { useLazyGetDropDownTenantsQuery } from "@/services/tenant.service";
import { RentalForm } from "@/types/rental.type";
import { moneyRegex } from "@/utils/regex";
import _ from "lodash";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import Select from 'react-select';
import { darkSelectStyles, lightSelectStyles } from "../transaction-queries";
import useColorMode from "@/hook/useColorMode";
import { IDropdown } from "@/constants/default";

export default function Information() {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { state: { tenant_id, id } } = useLocation()
    const [getTenants, { data: tenants }] = useLazyGetDropDownTenantsQuery({ refetchOnFocus: true, refetchOnReconnect: true })
    const { data: businessUnits } = useGetDropDownBusinessUnitsQuery({status: `${EnumStatus.ACTIVE},${EnumStatus.INAVTIVE}`, checkExpired: false }, { refetchOnMountOrArgChange: true })
    const { register, formState: { errors }, control, setValue, watch, getValues, trigger } = useFormContext<RentalForm>()
    const [mode, setMode] = useState<ModeUI>(useColorMode().mode)
    const selectStyles = mode === ModeUI.DARK ? darkSelectStyles : lightSelectStyles;

    useEffect(() => {
        getTenants({})
    }, [tenant_id])

    useEffect(() => {
        const handler = () => {
          let updated = localStorage.getItem('color-theme');
          if(updated) {
            updated = JSON.parse(updated)
            if(updated === ModeUI.AUTO) {
              updated = window.matchMedia && window.matchMedia("(prefers-color-scheme:dark)").matches ? ModeUI.DARK : ModeUI.LIGHT
            }
            setMode(updated as ModeUI)
          }
        }
    
        window.addEventListener('local-storage-updated', handler);
        return () => window.removeEventListener('local-storage-updated', handler);
    }, [])

    useEffect(() => {
        if (tenants && tenants?.length > 0 && tenant_id) {
            const data = getValues("tenant_ids") || []
            setValue("tenant_ids", [...data, tenant_id])
        }
    }, [tenants, tenant_id])

    return (
        <div className="grid grid-cols-1 gap-9 sm:grid-cols-2 overflow-x-hidden overflow-y-auto px-6">
            <div>
                {/* <div className="mb-3">
                    <label className="mb-1 block dark:text-white">
                        {t("rental.type")}
                    </label>
                    <Controller
                        name="action_add"
                        control={control}
                        defaultValue={ListActionAdd[0].value}
                        render={({field: {onChange, value}}) => <DropDownList selected={value} setSelected={onChange} list={ListActionAdd || []} />}
                    />
                </div> */}
                <div className="mb-3">
                    <label className="mb-1 block text-black dark:text-white">
                        {t("rental.ta_ref_no")}
                    </label>
                    <input
                        type="text"
                        placeholder={t("placeholder.ta_ref_no")}
                        className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:text-white dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                        {...register("ta_ref_no", { required: t("validation.required") })}
                    />
                    {errors.ta_ref_no && <p className="mt-1 text-rose-600">{errors.ta_ref_no.message}</p>}
                </div>
                {/* <div className="mb-3">
                    <label className="mb-1 block dark:text-white capitalize">
                        {t("rental.tenant")}
                    </label>
                    <div className="flex flex-wrap">
                        <Controller
                            name="tenant_id"
                            control={control}
                            render={({ field: { onChange, value } }) => <div className="grow">
                                <DropDownList selected={value} setSelected={onChange} list={tenants || []} />
                            </div>}
                        />
                        <button type="button" className="rounded bg-primary ms-3 p-1.5 px-3 text-white hover:bg-opacity-90" onClick={() => navigate(location, { state: { modal: "/settings/tenants/add", fromModal: id ? "/rentals/edit" : "/rentals/add", id: id } })}>Add</button>
                    </div>
                </div> */}
                <div className="mb-3">
                    <label className="mb-1 block dark:text-white capitalize">
                        {t("rental.tenant")}
                    </label>
                    <div className="flex flex-wrap">
                        <Controller
                            name="tenant_ids"
                            control={control}
                            defaultValue={[]}
                            render={({ field: { onChange, value } }) => {
                                const data = tenants?.filter(tenant => value?.includes(tenant.value)) || []
                                return (
                                    <Select
                                        key={mode.toString()}
                                        styles={selectStyles}
                                        options={tenants ? tenants : []}
                                        isMulti={true}
                                        className="react-select-container flex-1"
                                        onChange={(selectedOptions) => onChange(selectedOptions.map(option => option.value))}
                                        value={data}
                                    />
                                )
                            }}
                        />
                        <button type="button" className="rounded bg-primary ms-3 p-1.5 px-3 text-white hover:bg-opacity-90" onClick={() => navigate(location, { state: { modal: "/settings/tenants/add", fromModal: id ? "/rentals/edit" : "/rentals/add", id: id } })}>Add</button>
                    </div>
                </div>
                <div className="mb-3">
                    <label className="mb-1 block dark:text-white">
                        {t("rental.business_unit")}
                    </label>
                    <Controller
                        name="business_unit_id"
                        control={control}
                        render={({ field: { onChange, value } }) => <DropDownList selected={value} setSelected={onChange} list={businessUnits || []} />}
                    />
                </div>
                <div className="mb-3">
                    <label className="mb-1 block dark:text-white">
                        {t("rental.room")}
                    </label>
                    <Controller
                        name="room_id"
                        control={control}
                        render={({ field: { onChange, value } }) => <DropDownList selected={value} setSelected={onChange} list={_.find(businessUnits || [], i => i.value === watch('business_unit_id'))?.rooms || []} />}
                    />
                </div>
                <div className="mb-3">
                    <label className="mb-1 block dark:text-white">
                        {t("rental.type")}
                    </label>
                    <Controller
                        name="type"
                        control={control}
                        defaultValue={1}
                        render={({ field: { onChange, value } }) => {
                            return (
                                <div className="flex gap-8 mt-2">
                                    <div className="flex align-items-center gap-2">
                                        <input type="radio" value={1} checked={Number(value) === 1} onChange={onChange} />
                                        <label className="dark:text-white">{t("rental.will_rent")}</label>
                                    </div>
                                    <div className="flex align-items-center gap-2">
                                        <input type="radio" value={2} checked={Number(value) === 2} onChange={onChange} />
                                        <label className="dark:text-white">{t("rental.type_renew")}</label>
                                    </div>
                                </div>
                            )
                        }}
                    />
                </div>
            </div>
            <div>
                {/* <div className="mb-3">
                    <label className="mb-1 block text-black dark:text-white">
                        {t("rental.ta_ref_no")}
                    </label>
                    <input
                        type="text"
                        placeholder={t("placeholder.ta_ref_no")}
                        className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:text-white dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                        {...register("ta_ref_no")}
                    />
                    { errors.ta_ref_no && <p className="mt-1 text-rose-600">{errors.ta_ref_no.message}</p>}
                </div> */}
                <div className="mb-3">
                    <label className="mb-1 block text-black dark:text-white">
                        {t("rental.start_date")}
                    </label>
                    <input
                        type="date"
                        placeholder={t("placeholder.business_unit_account")}
                        className="custom-input-date-1 w-full rounded border-[1.5px] text-black dark:text-white border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary disabled:opacity-75"
                        {...register("start_date", {
                            required: t("validation.required"),
                            validate: {
                                checkedValidDate: (value, { end_date }) => {
                                    errors.end_date && trigger("end_date")
                                    return _.isEmpty(end_date) || moment(value).isBefore(moment(end_date)) || t("validation.start_date_before_end_date")
                                }
                            }
                        })}
                    />
                    {errors.start_date && <p className="mt-1 text-rose-600">{errors.start_date.message}</p>}
                </div>
                <div className="mb-3">
                    <label className="mb-1 block text-black dark:text-white">
                        {t("rental.end_date")}
                    </label>
                    <input
                        type="date"
                        placeholder={t("placeholder.business_unit_account")}
                        className="custom-input-date-1 w-full rounded border-[1.5px] text-black dark:text-white border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary disabled:opacity-75"
                        {...register("end_date", {
                            required: t("validation.required"),
                            validate: {
                                checkedValidDate: (value, { start_date }) => {
                                    errors.start_date && trigger("start_date")
                                    return _.isEmpty(start_date) || moment(value).isAfter(moment(start_date)) || t("validation.end_date_after_start_date")
                                }
                            }
                        })}
                    />
                    {errors.end_date && <p className="mt-1 text-rose-600">{errors.end_date.message}</p>}
                </div>
                <div className="mb-3">
                    <label className="mb-1 block text-black dark:text-white">
                        {t("rental.agent_name")}
                    </label>
                    <input
                        type="text"
                        placeholder={t("placeholder.agent_name")}
                        className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:text-white dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                        {...register("agent_name", { required: t("validation.required") })}
                    />
                    {errors.agent_name && <p className="mt-1 text-rose-600">{errors.agent_name.message}</p>}
                </div>
                <div className="mb-3">
                    <label className="mb-1 block text-black dark:text-white">
                        {t("rental.rent_amount")}
                    </label>
                    <input
                        type="text"
                        placeholder={t("placeholder.rent_amount")}
                        className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary dark:text-white"
                        {...register("rent_amount", {
                            required: t("validation.required"),
                            pattern: {
                                value: moneyRegex,
                                message: t("validation.incorrect_money"),
                            }
                        })}
                    />
                    {errors.rent_amount && <p className="mt-1 text-rose-600">{errors.rent_amount.message}</p>}
                </div>
                <div className="mb-3">
                    <label className="mb-1 block text-black dark:text-white">
                        {t("rental.deposit_amount")}
                    </label>
                    <input
                        type="text"
                        placeholder={t("placeholder.deposit_amount")}
                        className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary dark:text-white"
                        {...register("deposit_amount", {
                            required: t("validation.required"),
                            pattern: {
                                value: moneyRegex,
                                message: t("validation.incorrect_money"),
                            }
                        })}
                    />
                    {errors.deposit_amount && <p className="mt-1 text-rose-600">{errors.deposit_amount.message}</p>}
                </div>
                <div className="mb-3">
                    <label className="mb-1 block text-black dark:text-white">
                        {t("rental.deposit_date")}
                    </label>
                    <input
                        type="date"
                        placeholder={t("placeholder.deposit_date")}
                        className="custom-input-date-1 w-full rounded border-[1.5px] text-black dark:text-white border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary disabled:opacity-75"
                        {...register("deposit_date", { required: t("validation.required") })}
                    />
                    {errors.deposit_date && <p className="mt-1 text-rose-600">{errors.deposit_date.message}</p>}
                </div>
                {/* <div className="mb-3">
                    <label className="mb-1 block text-black dark:text-white">
                        {t("rental.late_fee")}
                    </label>
                    <input
                        type="number"
                        placeholder={t("placeholder.late_fee")}
                        className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary dark:text-white"
                        {...register("late_fee", {
                            min: {
                                value: 1,
                                message: t("validation.min_1"),
                            },
                        })}
                    />
                    { errors.late_fee && <p className="mt-1 text-rose-600">{errors.late_fee.message}</p>}
                </div>
                <div className="mb-3">
                    <label className="mb-1 block text-black dark:text-white">
                        {t("rental.late_grace")}
                    </label>
                    <input
                        type="number"
                        placeholder={t("placeholder.late_grace")}
                        className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary dark:text-white"
                        {...register("late_grace", {
                            min: {
                                value: 1,
                                message: t("validation.min_1"),
                            },
                        })}
                    />
                    { errors.late_grace && <p className="mt-1 text-rose-600">{errors.late_grace.message}</p>}
                </div> */}
            </div>
        </div>
    )
}
